import { ReplaySubject } from 'rxjs';

export const batchRowsGetReplay = new ReplaySubject(1);
